/** Array.prototype.flatMap */
require('core-js/modules/es.array.flat-map');

/** Promise.prototype.finally */
require('core-js/modules/es.promise.finally');

/** Object.hasOwn */
require('core-js/modules/es.object.has-own');
